"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _currency = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/currency.store"));
var _flightsPaxPage = _interopRequireDefault(require("./page/flights-pax-page.store"));
var _flightsDomesticSearchPage = _interopRequireDefault(require("./page/flights-domestic-search-page.store"));
var _flightsAsyncSearchPage = _interopRequireDefault(require("./page/flights-async-search-page.store"));
var _completeSearchPage = _interopRequireDefault(require("./page/complete-search-page.store"));
var _stepByStepPage = _interopRequireDefault(require("./page/step-by-step-page.store"));
var _user = _interopRequireDefault(require("@tajawal/ct-web-account-sdk/lib/stores/user.store"));
var _config = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/config.store"));
var _flightInfo = _interopRequireDefault(require("./flight-info.store"));
var _flightsPaxPageV = _interopRequireDefault(require("./page/flights-pax-page-V2.store"));
var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
(0, _mobx.configure)({
  enforceActions: "observed"
});
var FlightsStore = exports.default = (_class = function () {
  function FlightsStore(_ref) {
    var initialState = _ref.initialState,
      V2 = _ref.V2,
      isMobile = _ref.isMobile;
    (0, _classCallCheck2.default)(this, FlightsStore);
    this.config = void 0;
    this.currency = void 0;
    this.flightsAsyncSearchPage = void 0;
    this.flightsDomesticSearchPage = void 0;
    this.flightsPaxPage = void 0;
    this.flightInfo = void 0;
    this.user = void 0;
    this.completeSearchPage = void 0;
    this.stepByStepSearchPage = void 0;
    var data = (0, _get2.default)(initialState, "config.data", {});
    var device = (0, _get2.default)(data, "device", {});
    var configData = _objectSpread(_objectSpread({}, data), {}, {
      device: _objectSpread(_objectSpread({}, device), {}, {
        isMobile: isMobile
      })
    });
    this.config = new _config.default(_objectSpread(_objectSpread({}, initialState.config || {}), {}, {
      data: configData
    }));
    this.currency = new _currency.default(initialState.currency);
    var $env = {
      config: this.config,
      currency: this.currency
    };
    var PaxPageStore = V2 ? _flightsPaxPageV.default : _flightsPaxPage.default;
    this.flightsAsyncSearchPage = new _flightsAsyncSearchPage.default(initialState.flightsAsyncSearchPage, $env);
    this.flightsDomesticSearchPage = new _flightsDomesticSearchPage.default(initialState.flightsDomesticSearchPage, $env);
    this.flightsPaxPage = new PaxPageStore(initialState.flightsPaxPage, $env);
    this.flightInfo = new _flightInfo.default(initialState.flightInfo, $env);
    this.user = new _user.default(initialState.user);
    this.completeSearchPage = new _completeSearchPage.default(initialState.completeSearchPage, $env, this.flightInfo);
    this.stepByStepSearchPage = new _stepByStepPage.default(initialState.stepByStepSearchPage, $env, this.flightInfo);
  }
  (0, _createClass2.default)(FlightsStore, [{
    key: "resources",
    get: function get() {
      return this.flightInfo.resources;
    }
  }, {
    key: "amenities",
    get: function get() {
      return this.flightInfo.amenities;
    }
  }, {
    key: "richContent",
    get: function get() {
      return this.flightInfo.richContent;
    }
  }, {
    key: "refundInfo",
    get: function get() {
      return this.flightInfo.fareRulesInfo;
    }
  }, {
    key: "loyalty",
    get: function get() {
      return this.flightInfo.loyalty;
    }
  }, {
    key: "fareRules",
    get: function get() {
      return this.flightInfo.fareRules;
    }
  }, {
    key: "$resources",
    get: function get() {
      return this.flightInfo.$resources;
    }
  }, {
    key: "$fare",
    get: function get() {
      return this.flightInfo.$fare;
    }
  }, {
    key: "flightsHomeUrl",
    get: function get() {
      return (0, _client.replaceParams)(_constants.APP_ROUTES.FLIGHTS_HOME, {
        language: this.config.language
      });
    }
  }]);
  return FlightsStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "resources", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "resources"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "amenities", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "amenities"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "richContent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "richContent"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "refundInfo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "refundInfo"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "loyalty", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "loyalty"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fareRules", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "fareRules"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "$resources", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "$resources"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "$fare", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "$fare"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "flightsHomeUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "flightsHomeUrl"), _class.prototype)), _class);